/* eslint-disable import/prefer-default-export */

import { CREATE_USER_ROUTES } from '../utils/ROUTES'

export function isSubMenu(pathname: string): boolean {
  return CREATE_USER_ROUTES.some((route) => pathname.includes(route))
}
